import React from 'react';
import styled, { keyframes } from 'styled-components';
import { spacing } from '../../design-system/tokens/spacing';
import { breakpoints } from '../../design-system/tokens/breakpoints';

const shimmer = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
`;

const Bone = styled.div<{ $h?: string; $w?: string }>`
  background: ${props => props.theme.colors.surfaceHover};
  border-radius: 8px;
  height: ${props => props.$h ?? '16px'};
  width: ${props => props.$w ?? '100%'};
  animation: ${shimmer} 1.5s ease-in-out infinite;
`;

const CardBone = styled.div`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: ${spacing[6]};
  min-height: 160px;
`;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]};
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing[6]};

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: 2fr 1fr;
  }
`;

export const DashboardSkeleton: React.FC = () => (
  <Page aria-busy="true" aria-label="Loading dashboard">
    <div>
      <Bone $h="14px" $w="120px" />
      <Bone $h="32px" $w="280px" style={{ marginTop: spacing[3] }} />
      <Bone $h="16px" $w="400px" style={{ marginTop: spacing[3] }} />
    </div>
    <Row>
      <CardBone><Bone $h="24px" $w="60%" /><Bone style={{ marginTop: spacing[4] }} /></CardBone>
      <CardBone><Bone $h="24px" $w="50%" /><Bone style={{ marginTop: spacing[4] }} /></CardBone>
    </Row>
    <CardBone style={{ minHeight: 100 }}><Bone $h="20px" $w="30%" /></CardBone>
    <Row>
      <CardBone style={{ minHeight: 280 }} />
      <CardBone style={{ minHeight: 280 }} />
    </Row>
  </Page>
);

export default DashboardSkeleton;
